import brands from 'src/json/brands.json'
import categories from 'src/json/categories.json'

export function getBrandByName(name: string) {
  return brands.find((brand: any) => brand.brand === name)
}

export function getBrandBySlug(slug: string, locale: string) {
  const filteredBrands = brands.filter(
    (brand: any) => brand.slug === `/${slug}`
  )
  if (filteredBrands && filteredBrands.length > 1) {
    const localeBrands = filteredBrands.filter(
      (brand: any) => brand.locale === locale
    )
    if (localeBrands.length > 0) {
      return localeBrands[0]
    }
  }
  return filteredBrands[0] ? filteredBrands[0] : null
}

export function getBrandById(brandId: string, locale?: string): any {
  const filteredBrands = brands.filter(
    (brand: any) => brand.centraId === brandId
  )
  if (filteredBrands.length > 1 && locale) {
    const localeBrands = filteredBrands.filter(
      (brand: any) => brand.locale === locale
    )
    if (localeBrands.length > 0) {
      return localeBrands[0]
    }
  }
  return filteredBrands[0] ? filteredBrands[0] : {}
}

export function getBrandCategories(brandId: string): any {
  return categories.filter(
    (category: any) => category.brands && category.brands.includes(brandId)
  )
}
